module.exports = __webpack_public_path__ + "static/scale-model-of-crescent-hill-reservoir-in-louisville-kentucky-d5fd6500ff1a6c4a279bae313c4a3890.png";